import ErrorBoundary from "@mirage/components/errorBoundary/ErrorBoundary";
import { PrePublicPortalWLRoutingService } from "./services/PrePublicPortalWLRoutingService";
import { Suspense, useEffect, useState } from "react";
import CircularCentered from "@mirage/components/fallbacks/CircularCentered";
import { Navigate, Route, Routes } from "react-router-dom";
import { PrePublicPortalWlForm } from "./pages/form/PrePublicPortalWlForm";
import { GlobalStyle, Page } from "govuk-react";
import "./app.css";
import { PrePpWlDisclaimer } from "./pages/disclaimer/PrePpWlDisclaimer";
import { useSetRecoilState } from "recoil";
import { gazetteerState } from "@mirage/store/gazetteerStore";
import { GovReactCustomHeader } from "@publicMirage/components/govReact/GovReactCustomHeader";
import { PrePublicPortalWlPaymentsSuccess } from "./pages/payments/PrePublicPortalWlPaymentsSuccess";
import { PrePpWlSubmitSuccess } from "./pages/submitResult/PrePpWlSubmitSuccess";
import { PrePpWlSubmitError } from "./pages/submitResult/PrePpWlSubmitError";
import { ClientSettingsService } from "@mirage/services/ClientSettingsService";
import { PrePublicPortalWlConstants } from "@shared/prePublicPortalWestLindsay/constants";
import { IPrePpWLClientSettings, useSetSessionStorage } from "@mirage/hooks/useSessionStorage";
import { PrePpWlFormFeeCalculator } from "@shared/prePublicPortalWestLindsay/utils/PrePpWlFormFeeCalculator";

const router = new PrePublicPortalWLRoutingService();

export const PrePublicPortalWestLindsay = () => {
    const [config, setConfig] = useState<Pick<IPrePpWLClientSettings, "logo.png" | "logo.svg" | "HEADER_TEXT" | "HEADER_URL">>({
        "logo.png": "",
        "logo.svg": "",
        HEADER_TEXT: "",
        HEADER_URL: "",
    });
    const setGazetteer = useSetRecoilState(gazetteerState);
    const appName = PrePublicPortalWlConstants.AppName;
    const setSessionStorage = useSetSessionStorage(appName);

    useEffect(() => {
        ClientSettingsService.getInstance(appName).then((service) => {
            const clientSettings = service.getSettings() as IPrePpWLClientSettings;
            setGazetteer({
                localGazetteerToken: clientSettings.LOCAL_GAZETTEER_TOKEN,
                localGazetteerUrl: clientSettings.LOCAL_GAZETTEER_URL,
                nationalGazetteerToken: clientSettings.NATIONAL_GAZETTEER_TOKEN,
                nationalGazetteerUrl: clientSettings.NATIONAL_GAZETTEER_URL,
            });
            setConfig({
                "logo.png": clientSettings["logo.png"],
                "logo.svg": clientSettings["logo.svg"],
                HEADER_TEXT: clientSettings.HEADER_TEXT,
                HEADER_URL: clientSettings.HEADER_URL,
            });
            if (clientSettings.HTML_TEMPLATE_TITLE) {
                document.title = clientSettings.HTML_TEMPLATE_TITLE;
            }
            if (typeof clientSettings.PAYMENT_FAKE_AMOUNT === "string") {
                PrePpWlFormFeeCalculator.setFakeFeeAmount(Number(clientSettings.PAYMENT_FAKE_AMOUNT));
            }
            setSessionStorage((p) => {
                return {
                    ...p,
                    clientSettings,
                };
            });
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Page id="pre-application-wl" header={<GovReactCustomHeader {...config} />}>
            <ErrorBoundary key={location.pathname}>
                <Suspense fallback={<CircularCentered />}>
                    <Routes>
                        <Route path="" element={<PrePpWlDisclaimer />} />
                        <Route path={`${router.Form}/:step`} element={<PrePublicPortalWlForm />} />
                        <Route path={router.Payments + "/:uuid"} element={<PrePublicPortalWlPaymentsSuccess />} />
                        <Route path={router.SubmitSuccess} element={<PrePpWlSubmitSuccess />} />
                        <Route path={router.SubmitError} element={<PrePpWlSubmitError />} />
                        <Route path="*" element={<Navigate to={`${router.Root}`} />} />
                    </Routes>
                </Suspense>
            </ErrorBoundary>
            <GlobalStyle />
        </Page>
    );
};
